module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-2.fc2135e1.jpg";